import Repo from '../repos/Repo';

export default class NewsRepo extends Repo{

    constructor($auth){
        super($auth, 'news');
    }

    all(q){
        return super.all(q, "creator")
    }

    store(data){
        return super.store(data, "")
    }

    updateSeen(id){
        return this.http.put(this.resource + "/" + id + "/seen").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }


    get(id){
        return super.get(id, "")
    }
}



// WEBPACK FOOTER //
// ./src/repos/NewsRepo.js